<main class="p-4 container-lg">
  <h2>Redirecting...</h2> 
</main>
